/** @typedef {Record<string, string | Record<string, unknown>>} LocaleTree */
/** @type {LocaleTree} */
const de = {
  app: {
    defaultDocTitle: "peplies consult - Sports Marketing Consultants",
  },
  nav: {
    about: "Über uns",
    hallOfFame: "Hall of Fame",
    services: "Leistungen",
    servicesAthletes: "Leistungen für Athleten",
    servicesCompanies: "Leistungen für Unternehmen",
    references: "Referenzen",
    refAthletes: "Referenzen Athleten",
    refCompanies: "Referenzen Unternehmen",
    press: "Presse",
    campaigns: "Kampagnen",
    campaignsPrint: "PR | Print | Plakat",
    campaignsTv: "TV Werbespots",
    publications: "Publikationen",
    scientificAdvisoryBoard: "Wissenschaftlicher Beirat",
    toggleMenu: "Navigationsmenu umschalten",
  },
  auth: {
    login: "Anmelden",
    logout: "Abmelden",
    password: "Passwort",
    passwordPlaceholder: "Passwort eingeben",
    wrongPassword: "Falsches Passwort",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort verbergen",
    notice: "Dieses Login steuert nur die Sichtbarkeit der Navigation im Frontend und ist keine sichere Authentifizierung.",
    unavailable: "Anmeldung ist nicht verfugbar, weil kein Passwort konfiguriert ist.",
  },
  footer: {
    linksHeading: "LINKS",
    about: "Über uns",
    services: "Leistungen",
    contact: "Kontakt",
    legal: "Impressum",
    privacy: "Datenschutz",
    servicesBlockHeading: "LEISTUNGEN",
    servicesAthletes: "Leistungen für Athleten",
    servicesCompanies: "Leistungen für Unternehmen",
    rights: "Alle Rechte vorbehalten.",
    companyName: "peplies consult GmbH",
    companyStreet: "Höhenstraße 12",
    companyPostalCode: "65321",
    companyCity: "Heidenrod",
    copyrightBrand: "peplies consult - Sports Marketing Consultants",
  },
  intro: {
    title: "Über uns",
    p1: 'Wir sind "Consultants of Choice" für nationale und internationale Athleten, Vereine, Verbände und Wirtschaftsunternehmen im Bereich des Sportmarketing und Sportsponsoring.',
    p2: "Als Schwesterunternehmen der peplies consult - Marketing Consultants und der peplies consult - Executive Consultants sowie als Kooperationspartner weltweit führender sportökonomischer, sportrechtlicher und sportmedizinischer Universitätsfakultäten sind wir Praxis und Wissenschaft zugleich verpflichtet.",
    p3: "Wir lassen uns messen an der Zufriedenheit unserer Mandanten und unserem Beitrag für Wirtschaft, Sport und Gesellschaft.",
    contactCta: "Kontakt",
  },
  servicesSection: {
    title: "Leistungen",
    subtitle: "Unsere Leistungen im Überblick.",
    athletesTitle: "Leistungen für Athleten",
    athletesBody:
      'Für unsere Athletinnen und Athleten halten wir - auch unter Einbindung assoziierter Partner und Netzwerke - alle Maßnahmen einer ganzheitlichen Betreuung auf qualitativ höchstem Niveau vor ("18-Punkte-Programm"). Weitreichende internationale Referenzen bestehen vor allem in allen Bereichen des Wintersports (Ski Alpin, Biathlon, Skispringen, Nordische Kombination, Bob, Rodel) sowie innerhalb der Sportarten Tennis, Golf, Reiten und Leichtathletik.',
    companiesTitle: "Leistungen für Unternehmen",
    companiesBody:
      "Für Wirtschaftsunternehmen, die bereits Sportsponsoring betreiben, bieten wir Maßnahmen zur Analyse, Kontrolle und Optimierung ihrer Sponsoringkonzepte und der korrespondierenden Projekte sowie projektflankierende Maßnahmen an; für Wirtschaftsunternehmen, die den Eintritt in den Bereich des Sportsponsorings planen, bieten wir Marktforschung und Konzeptentwicklung an. Unsere Leistungen umfassen: Sportsponsoringkonzepte, Marktforschung & Controlling, projektflankierende Maßnahmen sowie Scouting und Akquisition von Sportlern.",
  },
  clients: {
    title: "Unternehmen Sportrechtevermarktung/Sportsponsoring",
  },
  contact: {
    docTitle: "peplies consult - Send us a message",
    modalTitle: "Kontakt",
    logoAlt: "peplies consult",
    close: "Schließen",
    callUs: "Rufen Sie uns an:",
    writeUs: "Schreiben Sie uns an:",
    mailUs: "Mailen Sie uns an:",
    country: "Deutschland",
    companyName: "peplies consult GmbH",
    street: "Höhenstraße 12",
    postalCode: "65321",
    city: "Heidenrod",
  },
  privacy: {
    docTitle: "peplies consult - Datenschutz",
    title: "Datenschutzerklärung",
  },
  legal: {
    docTitle: "peplies consult - Impressum",
    title: "Impressum",
    tmgaHeading: "Angaben gemäß § 5 TMG",
    country: "Deutschland",
    contact: "Kontakt",
    vatHeading: "Steuernummer/Umsatzsteuer-ID",
    taxNumberLine: "Steuernummer 043 241 09523, Finanzamt Wiesbaden II",
    vatIntro: "Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:",
    managingDirector: "Geschäftsführender Gesellschafter",
    registerHeading: "Registereintrag im Handelsregister",
    registerCourtLabel: "Registergericht:",
    registerCourt: "Amtsgericht Wiesbaden",
    registerNumberLabel: "Registernummer:",
    responsibleHeading: "Verantwortlich für den Inhalt nach § 18 MStV:",
  },
  athletesPage: {
    docTitle: "peplies consult - Athletes",
    title: "Aktuelle Athleten",
    subtitle: "Athletinnen und Athleten, für die die peplies consult GmbH Vermarktungsverantwortung hat oder hatte:",
  },
  athleteDetail: {
    docTitle: "peplies consult - Sports Marketing Consultants",
    notFound: "Athlet nicht gefunden",
    birthday: "Geburtstag:",
    discipline: "Sportdisziplin:",
    club: "Verein:",
    interests: "Interessen:",
    profession: "Beruf:",
    hobby: "Hobby:",
    achievements: "Erfolge:",
    photoCredit: "Foto: ",
  },
  companyReferences: {
    docTitle: "peplies consult - Unternehmen Sportrechtevermarktung/Sportsponsoring",
    title: "Unternehmen Sportrechtevermarktung/Sportsponsoring",
    pageIntro: "Auswahl von Unternehmen, die mit der peplies consult GmbH zusammenarbeiten und zusammengearbeitet haben:",
    reference: "Referenz",
  },
  hallOfFame: {
    docTitle: "peplies consult - Hall of Fame",
    title: "Hall of Fame",
    subtitle:
      '"Legenden des Sports" oder Projekte, für die die peplies consult GmbH Vermarktungsverantwortung hatte bzw. hat:',
    achievementsHeading: "Karriere-Highlights",
    noAchievements: "Keine Erfolge hinterlegt.",
    flipHint: "Mausbewegung oder Tippen zum Umdrehen",
  },
  press: {
    docTitle: "peplies consult - Press",
    title: "Presse",
    pageIntro: "Ausgewählte Berichterstattungen über die peplies consult GmbH:",
    openHint: "Zum Öffnen klicken",
    unavailable: "Dieses Dokument ist derzeit nicht verfugbar.",
    categories: {
      olympics: "Olympia",
      magazine: "Magazin",
      news: "News",
    },
  },
  publications: {
    docTitle: "peplies consult - Publications",
    title: "Publikationen",
    pageIntro: "Publikationen, an denen die peplies consult GmbH mitgewirkt hat:",
    isbn: "ISBN",
    openPdf: "PDF öffnen",
    openImage: "Bild vergrößern",
    empty: "Inhalte zu Publikationen werden derzeit vorbereitet.",
  },
  scientificAdvisoryBoard: {
    docTitle: "peplies consult - Scientific Advisory Board",
    title: "Wissenschaftlicher Beirat",
    sections: {
      sportsEconomics: {
        title: "Sportökonomie",
        members: [
          "Prof. Dr. Herbert Woratschek Universität Bayreuth",
          "Prof. Dr. Michael Wehrheim (gest.) Universität Marburg, European Business School (EBS) Oestrich-Winkel",
          "Prof. Dr. Guido Schafmeister Macromedia Hochschule für Medien und Kommunikation München",
        ],
      },
      sportsMedicine: {
        title: "Sportmedizin/Sportwissenschaft/Trainingslehre/Komplementärmedizin",
        members: [
          "Prof. Dr. Dieter Lazik Universität Potsdam, Universität Luxemburg",
          "Prof. Dr. Hartmut Schröder Universität Viadrina, Frankfurt/Oder",
          "Dr. Inge Gerding Bad Wildungen",
        ],
      },
    },
  },
  printCampaign: {
    docTitle: "peplies consult - PR,Print,Plakat",
    title: "PR | Print | Plakate",
    empty: "Kampagnenmaterial wird in Kurze hier veroffentlicht.",
    galleryIntro:
      "Auswahl von klassischen Kommunikationskampagnen, die die peplies consult GmbH geplant und umgesetzt hat:",
    imageSectionTitle: "Bildmotive",
    pdfSectionTitle: "PDF-Kampagnen",
    items: "Elemente",
    openImage: "Bild offnen:",
    openPdf: "PDF offnen:",
    openPdfCta: "Als PDF in neuem Tab ansehen",
  },
  tv: {
    docTitle: "peplies consult - TV Werbespots",
    title: "TV Werbespots",
    subtitle:
      "Auswahl von TV-Kampagnen, die die peplies consult GmbH geplant und umgesetzt hat:",
    videoNotSupported: "Ihr Browser unterstützt das Video-Tag nicht.",
  },
  athleteServices: {
    docTitle: "peplies consult - Services for Athletes",
    title: "Leistungen für Athleten",
    intro:
      'Für unsere Athletinnen und Athleten halten wir - auch unter Einbindung assoziierter Partner und Netzwerke - alle Maßnahmen einer ganzheitlichen Betreuung auf qualitativ höchstem Niveau vor ("18-Punkte-Programm"). Weitreichende internationale Referenzen bestehen vor allem in allen Bereichen des Wintersports (Ski Alpin, Biathlon, Skispringen, Nordische Kombination, Bob, Rodel) sowie innerhalb der Sportarten Tennis, Golf, Reiten und Leichtathletik.',
  },
  companyServices: {
    docTitle: "peplies consult - Services for Companies",
    title: "Leistungen für Unternehmen",
  },
  cookie: {
    message:
      "Wir speichern Einstellungen in Ihrem Browser (Local Storage). Nach „Alle akzeptieren“ werden Videos von Cloudinary (USA) geladen; dabei kann Ihre IP-Adresse übermittelt werden. Details in der Datenschutzerklärung.",
    acceptAll: "Alle akzeptieren",
    acceptNecessary: "Nur notwendige",
    decline: "Ablehnen",
    reopenSettings: "Cookie-Einstellungen ändern",
    externalMediaBlocked:
      "Externe Videos sind deaktiviert. Bitte „Cookie-Einstellungen ändern“ wählen und „Alle akzeptieren“, oder die Datenschutzerklärung lesen.",
  },
  language: {
    label: "Sprache",
    names: {
      de: "Deutsch",
      en: "English",
      fr: "Français",
      es: "Español",
    },
  },
  notFound: {
    docTitle: "peplies consult - Seite nicht gefunden",
    message: "Die angeforderte Seite wurde nicht gefunden.",
    home: "Zur Startseite",
  },
};

export default de;
